import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaSearchBarComponent} from './la-search-bar.component';
import {LaIconModule} from '..';

@NgModule({
  imports: [
    CommonModule,
    LaIconModule
  ],
  declarations: [LaSearchBarComponent],
  exports: [LaSearchBarComponent]
})
export class LaSearchBarModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaSearchBarModule,
      providers: []
    };
  }
}
